document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-collection-tabs]').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    const selectedColorEl = root.querySelector('[data-selected-color]');

    if (!tabs.length || !panels.length) return;

    const setLabel = (tab) => {
      if (selectedColorEl) selectedColorEl.textContent = tab.textContent.trim();
    };

    const selectedTab = () =>
      tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];

    const select = (tab, moveFocus) => {
      const controls = tab.getAttribute('aria-controls');

      tabs.forEach((t) => {
        const isCurrent = t === tab;
        t.classList.toggle('selected', isCurrent);
        t.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        t.tabIndex = isCurrent ? 0 : -1;
      });

      panels.forEach(panel => {
        panel.classList.toggle('hidden', panel.id !== controls);
      });

      setLabel(tab);
      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => select(tab, false));

      tab.addEventListener('mouseenter', () => setLabel(tab));
      tab.addEventListener('mouseleave', () => setLabel(selectedTab()));

      tab.addEventListener('keydown', (event) => {
        const last = tabs.length - 1;
        const i = tabs.indexOf(tab);
        let next;

        switch (event.key) {
          case 'ArrowLeft':
            next = i === 0 ? last : i - 1;
            break;
          case 'ArrowRight':
            next = i === last ? 0 : i + 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        event.preventDefault();
        select(tabs[next], true);
      });
    });
  });
});
